import {
  CRMFilterOverride,
  CrmObjectDependencies,
  DueDateCellComponent,
  StandardIds,
  SystemFieldIds,
  TableCustomCell,
  TaskCustomColumns,
  UserCellComponent,
  UserFilterChipComponent,
  UserFilterInputComponent,
} from '@galaxy/crm/static';
import { Observable, of } from 'rxjs';
import { Services } from './interface';

export class TaskDependencies {
  constructor(private readonly services: Services) {}

  build(): CrmObjectDependencies {
    return {
      filterInputOverrides$: this.filterInputOverrides$(),
      tableCustomCells: this.tableCustomCells(),
    };
  }

  static build(services: Services): CrmObjectDependencies {
    const instance = new TaskDependencies(services);
    return instance.build();
  }

  private filterInputOverrides$(): Observable<CRMFilterOverride[]> {
    return of([
      {
        title: this.services.translationService.instant('CRM.TASK.LIST_OBJECTS_TABLE.CUSTOM_COLUMNS.ASSIGNED_TO'),
        fieldId: SystemFieldIds.ActivityOwnerID,
        filterInput: UserFilterInputComponent,
        filterChip: UserFilterChipComponent,
      },
    ]);
  }

  private tableCustomCells(): TableCustomCell[] {
    return [
      {
        fieldIds: [SystemFieldIds.ActivityOwnerID],
        columnDefinition: {
          id: TaskCustomColumns.AssignedTo,
          title: this.services.translationService.instant('CRM.TASK.LIST_OBJECTS_TABLE.CUSTOM_COLUMNS.ASSIGNED_TO'),
        },
        customCellComponent: UserCellComponent,
      },
      {
        fieldIds: [StandardIds.ActivityTaskDueDate, StandardIds.ActivityTaskStatus],
        columnDefinition: {
          id: StandardIds.ActivityTaskDueDate,
        },
        customCellComponent: DueDateCellComponent,
      },
    ];
  }
}
